export default __webpack_public_path__ + "static/media/4.045ab1ef.webp";